import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import FlowErrorBoundary from './components/FlowErrorBoundary';

// Simplified ResizeObserver error suppression
console.log('🔧 [DEBUG] Setting up ResizeObserver error suppression...');

let resizeObserverErrorCount = 0;

// Enhanced error handler to suppress ResizeObserver errors
const originalError = window.onerror;
window.onerror = function(message, source, lineno, colno, error) {
  if (message && message.includes && message.includes('ResizeObserver loop completed with undelivered notifications')) {
    resizeObserverErrorCount++;
    console.log(`🚫 [DEBUG] ResizeObserver error suppressed (${resizeObserverErrorCount})`);
    return true; // Suppress the error
  }
  
  // Call original error handler for other errors
  if (originalError) {
    return originalError.call(this, message, source, lineno, colno, error);
  }
  return false;
};

// Enhanced unhandled promise rejection handler
const originalUnhandledRejection = window.onunhandledpromiserejection;
window.onunhandledpromiserejection = function(event) {
  if (event.reason && event.reason.message && event.reason.message.includes('ResizeObserver loop completed with undelivered notifications')) {
    resizeObserverErrorCount++;
    console.log(`🚫 [DEBUG] ResizeObserver promise rejection suppressed (${resizeObserverErrorCount})`);
    event.preventDefault();
    return;
  }
  
  // Call original handler for other rejections
  if (originalUnhandledRejection) {
    return originalUnhandledRejection.call(this, event);
  }
};

// Monkey patch console.error to filter ResizeObserver errors
const originalConsoleError = console.error;
console.error = function(...args) {
  const message = args.join(' ');
  if (message.includes('ResizeObserver loop completed with undelivered notifications')) {
    resizeObserverErrorCount++;
    console.log(`🚫 [DEBUG] ResizeObserver console error suppressed (${resizeObserverErrorCount})`);
    return;
  }
  originalConsoleError.apply(console, args);
};

console.log('✅ [DEBUG] ResizeObserver error suppression configured');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <FlowErrorBoundary>
      <App />
    </FlowErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
